import {Button, Flex, Typography} from 'antd';
import DialogWrapper from 'Components/DialogView';
import React from 'react';
import styles from './styles';

const FlowTypeConfirmationPopup = ({
  openConfirmationDialog,
  setOpenConfirmationDialog,
  handleConfirmation,
}) => {
  return (
    <DialogWrapper
      closeDialogMethod={setOpenConfirmationDialog}
      open={openConfirmationDialog}
      style={{width: '40%', height: '30%', top: '5rem'}}>
      <Flex style={styles.container}>
        <Typography.Text style={{textAlign: 'center'}}>
          {'Are you sure you want to Credit the payment?'}
        </Typography.Text>
      </Flex>
      <div style={styles.buttonBox}>
        <Button
          danger
          type="primary"
          style={styles.button}
          onClick={() => handleConfirmation(true, false)}>
          {'Yes'}
        </Button>
        <Button
          type="primary"
          style={styles.button}
          onClick={() => handleConfirmation(false, false)}>
          {'No'}
        </Button>
      </div>
    </DialogWrapper>
  );
};

export default FlowTypeConfirmationPopup;
